import styles from 'styles/Root.css';
import React, { PropTypes } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import Locale from './Locale';
import App from 'views/App';

export default class Root extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    siteId: PropTypes.string.isRequired,
    onExit: PropTypes.func
  };

  get devTools () {
    if (__DEBUG__) {
      if (__DEBUG_NEW_WINDOW__) {
        if (!window.devToolsExtension) {
          require('../redux/utils/createDevToolsWindow')(this.props.store);
        } else {
          window.devToolsExtension.open();
        }
      } else if (!window.devToolsExtension) {
        const DevTools = require('containers/DevTools').default;
        return <DevTools />;
      }
    }
  }

  render () {
    return (
      <ReduxProvider store={this.props.store}>
        <Locale>
          <div className={styles.container}>
            <App siteId={this.props.siteId} onExit={this.props.onExit}/>
          </div>
        </Locale>
      </ReduxProvider>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/Root.js
 **/